/*eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';
import AddExamFormOrthac from '../../components/AddExamFormOrthac/AddExamFormOrthac';
import Header from '../../components/Header/Header';
import Loading from '../../components/Loading/Loading';
import LoadingProgressBar from '../../components/Loading/LoadingProgressBar';
import PageWithMenu from '../../components/PageWithMenu/PageWithMenu';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import SnackBar from '../../components/SnackBar/SnackBar';
import { headerVariables } from '../../components/Header/HeaderStyle';

import UploadIcon from '../../assets/svgs/UploadIcon';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import { useIsMounted } from '../../utils/useIsMounted';
import { setExamsAdded, setUploadExams } from '../../store/actions/exams';
import { setInstitution } from '../../store/actions/settings';

import { AddExamOrthacStyle } from './AddExamOrthacStyle';

const AddExamOrthac = () => {
  const dispatch = useDispatch();
  const examsAdded = useSelector((state) => state.exams.examsAdded);
  const inputFileRef = useRef();
  const institution = useSelector((state) => state.settings.institution);
  const isMounted = useIsMounted();
  const language = useSelector((state) => state.settings.language);
  const uploadExams = useSelector((state) => state.exams.uploadExams);
  const history = useHistory();

  const [dicomFiles, setDicomFiles] = useState([]);
  const [dicomDataExtracted, setDicomDataExtracted] = useState([]);
  const [dicomWarning, setDicomWarning] = useState();
  const [doctors, setDoctors] = useState([]);
  const [examsToRender, setExamsToRender] = useState([]);
  const [fileActive, setFileActive] = useState(false);
  const [institutionList, setInstitutionList] = useState([]);
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [loading, setLoading] = useState('');
  const [progress, setProgress] = useState(0);
  const [loadingProgressBar, setLoadingProgressBar] = useState('');
  const [pageWithMenuStyle, setPageWithMenuStyle] = useState();
  const [selectedInstitution] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [uploadPath, setUploadPath] = useState(false);
  const [dicomData ,setDicomData] = useState();
  const [inputFiles, setInputFiles] = useState([]);

  const isInstitutionHeadquarters = useMemo(
    () => institution && institution.is_headquarters,
    [institution]
  );

  useEffect(() => {
    // Exibe alerta ao atualizar a pagina
    const beforeUnloadHandler = (event) => {
      const message = translate('exitWithoutSaving', language);
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", beforeUnloadHandler);

    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    };
  }, []);

  useEffect(() => {
    (async () => {
      // Limpa lista de exames ao recarregar a pagina
      dispatch(setUploadExams([]));
      const response = await Api.removeTempImages();
    })();
  }, [history.action]);

  useEffect(() => {
    (async () => {
      if (isInstitutionHeadquarters) {
        if (!isMounted()) {
          return;
        }

        setLoading('loadingRegisteredInstitutions');

        const response = await Api.getNotHeadquartersInstitution();

        if (response?.data?.result?.length) {
          setInstitutionList(response.data.result);
        }

        setLoading('');
      }
    })();
  }, [isInstitutionHeadquarters, isMounted]);

  useEffect(() => {
    const currentInstitutionOptions = [{ key: 0, value: '', text: '' }];

    institutionList.forEach((i) => {
      if (i && i.id && i.name && i.name.length) {
        currentInstitutionOptions.push({
          key: i.id,
          value: i.id,
          text: i.name,
        });
      }
    });

    setInstitutionOptions([...currentInstitutionOptions]);
  }, [institutionList]);

  useEffect(() => {
    (async () => {
      if (!isMounted()) {
        return;
      }

      setLoading('loadingRegisteredDoctors');

      const response = await Api.getDoctorUsers();

      if (response?.status === 200 || response?.data?.length) {
        setDoctors(response?.data);
      }

      setLoading('');
    })();
  }, [isMounted]);

  useEffect(() => {
    if (doctors?.length) {
      setPageWithMenuStyle({
        paddingTop: `${headerVariables.main.height.iphone + 52}px`,
      });
    }
  }, [doctors?.length]);

  useEffect(() => {
    (async () => {
      if (dicomFiles && dicomFiles?.length) {
        setLoadingProgressBar('readingDicomData');
        const dicomFormData = new FormData();

        const totalFiles = dicomFiles.length;
        let currentFile = 0;

        dicomFiles?.forEach((dicom, index) => {
          dicomFormData.append(
            `dicom${index + 1}`,
            dicom,
            `Dicom from ${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()} ${new Date().getHours()}-${new Date().getMinutes()}-${new Date().getSeconds()}`
          );

          currentFile += 1;
          setTimeout(() => {
            setProgress((currentFile / totalFiles) * 50); 
          }, index * 10);

        });

        setTimeout(() => {
          setDicomData(dicomFormData);
          setDicomFiles([]);
        }, totalFiles * 10);
      }
    })();
  }, [dicomFiles, language]);

  useEffect(() => {
    (async () => {
      if (dicomData && [...dicomData].length) {
        const response = await Api.getDicomData(dicomData);

        if (response?.status === 200 && response?.data?.length) {
          setDicomDataExtracted(response?.data);
        } else {
          setLoadingProgressBar('');
          setDicomWarning({
            type: 'error',
            text: 'errorReadingDicomData',
          });
        }
      }
    })();
  }, [dicomData]);

  useEffect(() => {
    if (!loading) {
      const timeout = setTimeout(() => {
        setDicomWarning(null);
      }, 3500);

      return () => clearTimeout(timeout);
    }

    return null;
  }, [loading]);

  useEffect(() => {
    if (dicomDataExtracted && dicomDataExtracted.length) {
      setLoadingProgressBar('extractingDataFromDicomFiles');
      const totalFiles = dicomDataExtracted.length;
      let currentFile = 0;
      const currentExamsAdded = [];
  
      dicomDataExtracted.forEach((dicom, index) => {
        if (dicom) {
          currentFile += 1;
  
          setTimeout(() => {
            setProgress(50 + (currentFile / totalFiles) * 50);
          }, index * 10);
  
          currentExamsAdded.push({ data: dicom });
        }
      });
  
      setTimeout(() => {
        dispatch(setExamsAdded([...examsAdded, ...currentExamsAdded]));
        setDicomDataExtracted([]);
        setLoadingProgressBar('');
      }, dicomDataExtracted.length * 10);
    }
    setProgress(0);
  }, [dicomDataExtracted, dispatch, examsAdded, language]);

  useEffect(() => {
    if (examsAdded?.length) {
      const currentUploadExams = [];
      const patientNameList = examsAdded
        .map((exam) =>
          exam?.data['Patient Name'] ? exam?.data['Patient Name'] : ''
        )
        .filter((value, index, self) => self.indexOf(value) === index);

      if (patientNameList?.length) {
        patientNameList?.forEach((patientName) => {
          if (patientName?.length) {
            const patientExamsAddedRaw = examsAdded?.filter(
              (exam) => exam?.data['Patient Name'] === patientName
            );

            if (patientExamsAddedRaw?.length) {
              const seriesInstanceUIDList = patientExamsAddedRaw
                .map((exam) =>
                  exam?.data['Series Instance UID'] ? exam.data['Series Instance UID'] : ''
                )
                .filter((value, index, self) => self.indexOf(value) === index);

              if (seriesInstanceUIDList?.length) {
                seriesInstanceUIDList?.forEach((seriesInstanceUID) => {
                  if (seriesInstanceUID?.length) {
                    const seriesAlreadyAdded = uploadExams?.exams?.find((exam) =>
                      exam?.seriesInstanceUID === seriesInstanceUID ? exam : null
                    );

                    const currentPatientSeriesRaw = examsAdded.find(
                      (exam) =>
                        exam?.data['Patient Name'] === patientName &&
                        exam?.data['Series Instance UID'] === seriesInstanceUID
                    );

                    if (currentPatientSeriesRaw?.data) {
                      const currentPatientSeriesList = examsAdded.filter(
                        (exam) =>
                          exam?.data['Patient Name'] === patientName &&
                          exam?.data['Series Instance UID'] === seriesInstanceUID
                      );

                      const uploadExam = {
                        acquisitionDate:
                          currentPatientSeriesRaw?.data['Acquisition Date'] ||
                          '',
                        bodyPartExamined:
                          currentPatientSeriesRaw?.data['Body Part Examined'] ||
                          '',
                        contentDate:
                          currentPatientSeriesRaw?.data['Content Date'] || '',
                        image:
                          currentPatientSeriesRaw?.data['image'] ||
                          '',
                        institutionName:
                          currentPatientSeriesRaw?.data['Institution Name'] ||
                          '',
                        patientId:
                          currentPatientSeriesRaw?.data['Patient ID'] || '',
                        patientAge:
                          currentPatientSeriesRaw?.data["Patient's Age"] || '',
                        patientBirthDate:
                          currentPatientSeriesRaw?.data['Patient Birth Date'] ||
                          '',
                        patientName,
                        patientSex:
                          currentPatientSeriesRaw?.data['Patient Sex'] || '',
                        sliceCount:
                          currentPatientSeriesList.length,
                        studyDate:
                          currentPatientSeriesRaw?.data['Study Date'] || '',
                        studyDescription:
                          currentPatientSeriesRaw?.data['Study Description'] ||
                          '',
                        studyInstanceUID:
                          currentPatientSeriesRaw?.data['Study Instance UID'] ||
                          '',
                        modality: currentPatientSeriesRaw?.data?.Modality || '',
                        accessionNumber:
                          currentPatientSeriesRaw?.data?.AccessionNumber || '',
                        studyId: currentPatientSeriesRaw?.data['Study Instance UID'] || '',
                        seriesInstanceUID:
                          currentPatientSeriesRaw?.data['Series Instance UID'] ||
                          '',
                        series: [
                          {
                            seriesDate: currentPatientSeriesRaw?.data['Series Date'] || '',
                            seriesDescription: currentPatientSeriesRaw?.data['Series Description'] || '',
                            seriesInstanceUID: currentPatientSeriesRaw.data['Series Instance UID'] || '',
                            images: (() => {
                              const PREVIEW_COUNT = 5;
                              const allImages = currentPatientSeriesList
                                ? currentPatientSeriesList
                                    .map((e) => (e?.data?.image ? e.data.image : null))
                                    .filter((p) => p)
                                : [];

                              if (!allImages.length) return [];
                              if (allImages.length <= PREVIEW_COUNT) return allImages;

                              const len = allImages.length;
                              const mid = Math.floor(len / 2);
                              const half = Math.floor(PREVIEW_COUNT / 2);

                              let start = mid - half;
                              if (start < 0) start = 0;
                              let end = start + PREVIEW_COUNT;
                              if (end > len) {
                                end = len;
                                start = Math.max(0, end - PREVIEW_COUNT);
                              }

                              return allImages.slice(start, end);
                            })(),
                          }
                        ],
                      };

                      if (!seriesAlreadyAdded && uploadExam) {
                        currentUploadExams.push(uploadExam);
                      }
                    }
                  }
                });
              }
            }
          }
          dispatch(
            setUploadExams([...uploadExams?.exams, ...currentUploadExams])
          );
          dispatch(setExamsAdded([]));
        });
      }
    }
  }, [dispatch, examsAdded, uploadExams]);

  const handleDeleteSerie = async (addExam, addExamSerie) => {
    if (addExam && addExam.series && addExam.series.length) {
      const currentUploadExams = uploadExams?.exams?.filter(
        (uE) =>
          uE.patientName.toLowerCase() !== addExam.patientName.toLowerCase() &&
          uE.seriesInstanceUID !== addExam.seriesInstanceUID
      );
      const serieToDelete = addExam.series.find(
        (serie) => serie.seriesInstanceUID === addExam.seriesInstanceUID
      );

      if (serieToDelete && addExam.series.length > 1) {
        const currentUploadExamsSeries = addExam.series.filter(
          (aES) => aES.seriesInstanceUID !== addExamSerie.seriesInstanceUID
        );
        const currentUploadExam = addExam;

        currentUploadExam.series = currentUploadExamsSeries;

        dispatch(setUploadExams([...currentUploadExams, currentUploadExam]));
      } else {
        dispatch(setUploadExams([...currentUploadExams]));
      }
    }
  };

  const handleShowMenu = () => setShowMenu(!showMenu);

  const onChangeInputFile = (event) => {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length
    ) {
      setInputFiles(Array.from(event.target.files));

      const currentDicomFiles = [];

      for (let i = 0; i < event.target.files.length; i += 1) {
        const dicom = event.target.files[i];

        if (!dicomFiles.find((dF) => dF.name === dicom.name)) {
          currentDicomFiles.push(dicom);
        }
      }

      if (currentDicomFiles.length) {
        setDicomFiles([...currentDicomFiles]);
      }
    }

    inputFileRef.current.value = '';
  };

  const handleChangeSelect = (value) => {
    const curretnInstitution = institutionList.find(
      (i) => `${i.id}` === `${value}`
    );

    if (curretnInstitution) {
      dispatch(setInstitution(curretnInstitution));
    }
  };

  useDeepCompareEffect(() => {
    setExamsToRender(uploadExams);
  }, [uploadExams, uploadExams?.id]);

  return (
    <AddExamOrthacStyle>
      <Header handleShowMenu={handleShowMenu} />
      <PageWithMenu showMenu={showMenu} menuStyle={pageWithMenuStyle}>
        <div className="add-exam-content">
          {isInstitutionHeadquarters ? (
            <>
              <h1 className="add-exam-title">
                {translate('selectInstitutionToRegisterExams', language)}
              </h1>
              <div className="add-exam-select-institution-wrapper">
                <SelectOptions
                  theme="soft-blue-outline"
                  options={institutionOptions}
                  value={selectedInstitution}
                  onChange={(value) =>
                    handleChangeSelect(value, institutionOptions)
                  }
                />
              </div>
            </>
          ) : (
            <>
              <h1 className="add-exam-title">
                {translate('selectImagesToRegisterExams', language)}
              </h1>
              <p className="add-exam-instruction">
                {translate('youCanChooseMoreExamToRegister', language)}.
              </p>
              <div
                className={`add-exam-form-container${
                  fileActive ? ' active' : ''
                }`}
              >
                <form
                  className="add-exam-form"
                  onSubmit={(event) => event.preventDefault()}
                >
                  <span className="icon">
                    <UploadIcon />
                  </span>
                  <p className="form-instruction">
                    {translate('uploadFiles', language).toUpperCase()}
                  </p>
                  <p className="input-file-extension">.dicom</p>
                  <input
                    ref={inputFileRef}
                    type="file"
                    className="input-file"
                    accept="*/dicom,.dcm, image/dcm, */dcm, .dicom"
                    directory={uploadPath ? '' : undefined}
                    webkitdirectory={uploadPath ? '' : undefined}
                    multiple
                    onChange={onChangeInputFile}
                    onFocus={() => setFileActive(!fileActive)}
                    onBlur={() => setFileActive(false)}
                  />
                </form>
              </div>
              {inputFiles && examsToRender?.exams?.length && !loading
                ? examsToRender?.exams?.map((exam, index) => {
                    return (
                      <div key={exam?.seriesInstanceUID}>
                        <AddExamFormOrthac
                          addExam={exam}
                          doctors={doctors}
                          examIndex={index + 1}
                          handleDeleteSerie={handleDeleteSerie}
                          handleLoading={setLoadingProgressBar}
                          handleProgress={setProgress}
                          reload={examsToRender?.id}
                          inputFiles={inputFiles}
                          setDicomWarning={setDicomWarning}
                        />
                      </div>
                    );
                  })
                : null}
            </>
          )}
        </div>
      </PageWithMenu>
      {loading?.length ? (
        <Loading message={`${translate(loading, language)}…`} />
      ) : null}
      {loadingProgressBar?.length ? (
        <LoadingProgressBar message={`${translate(loadingProgressBar, language)}…`} progress={progress} />
      ) : null}
      {dicomWarning?.type?.length &&
      dicomWarning?.text?.length ? (
        <div className="snack-bar-wrapper">
          <SnackBar
            type={dicomWarning.type}
            text={translate(dicomWarning.text, language)}
          />
        </div>
      ) : null}
    </AddExamOrthacStyle>
  );
};

export default AddExamOrthac;
